import React, { useState, useCallback, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import '../styles/globals.css'
import { Header } from '@/components/Header'
import { AIActionResult, ChatResponse } from '@/types/ai'
import { lazyWithRetry } from '@/app/router/lazyWithRetry'

// framer-motionを使用するコンポーネントを遅延ロード（framer-motionも自動的に遅延ロードされる）
const FloatingChatbotButton = lazyWithRetry(
    () => import('@/components/FloatingChatbotButton').then(module => ({ default: module.FloatingChatbotButton })),
    'floating-chatbot-button',
)
const AgentChat = lazyWithRetry(
    () => import('@/features/ai/components/AgentChat').then(module => ({ default: module.AgentChat })),
    'agent-chat',
)

export function RootLayout(): React.JSX.Element {
    const [isChatModalOpen, setIsChatModalOpen] = useState<boolean>(false)

    const handleAIActionExecuted = useCallback((results: AIActionResult[]): void => {
        const successfulActions = results.filter((result: AIActionResult) => result.success)
        if (successfulActions.length === 0) {
            return
        }
    }, [])

    const handleChatResult = useCallback((result: ChatResponse): void => {
    }, [])

    const handleOpenChat = useCallback((): void => {
        setIsChatModalOpen(true)
    }, [])

    const handleCloseChat = useCallback((): void => {
        setIsChatModalOpen(false)
    }, [])

    return (
        <div className="font-sans antialiased flex flex-col min-h-screen bg-background text-foreground">
            <Header />
            <main id="main-content" className="flex-1 flex flex-col" role="main" aria-label="メインコンテンツ">
                <Outlet />
            </main>

            <Suspense fallback={null}>
                <FloatingChatbotButton onOpenChat={handleOpenChat} />
            </Suspense>

            <Suspense fallback={null}>
                <AgentChat
                    mode="modal"
                    isOpen={isChatModalOpen}
                    onClose={handleCloseChat}
                    onResult={handleChatResult}
                    onActionExecuted={handleAIActionExecuted}
                    className=""
                    position="bottom-right"
                    showQuickActions={true}
                />
            </Suspense>
        </div>
    )
}
